import React, { Fragment } from "react";
import BubbleRows from "./components/BubbleRows";
import Checkmark from "components/Creation/components/checkmark";
import Question from "./components/Question";
const BubblesGrid = ({
  cellIndexContent,
  onClickedCell,
  selection,
  shouldAnimate,
  onClickedCancelCell,
  isWithinSubCategory,
  onQuestionAnswered,
}) => {
  const NO_OF_COLS = 6;
  //   const NO_OF_ROWS = 5;
  //   const MIDDLE_COL = NO_OF_COLS / 2;
  //   const MIDDLE_ROW = 2;
  //   const MIDDLE_BUBBLE_COL_SPAN = 2;
  //   const MIDDLE_BUBBLE_ROW_SPAN = 3;

  //   let maxNoOfCells =
  //     NO_OF_COLS * NO_OF_ROWS -
  //     (MIDDLE_BUBBLE_COL_SPAN * MIDDLE_BUBBLE_ROW_SPAN - 1);

  let gridColsClassName = `md:grid-cols-6`;

  console.log("JS cellIndexContent", cellIndexContent, selection);

  return (
    <Fragment>
      <div className={`md:grid ${gridColsClassName}`}>
        <BubbleRows
          noOfCols={NO_OF_COLS}
          noOfRows={3}
          middleCol={6 / 2}
          middleRow={2}
          middleBubbleColSpan={2}
          middleBubbleRowSpan={2}
          cellIndexContent={cellIndexContent}
          onClickedCell={onClickedCell}
          selection={selection}
          shouldAnimate={shouldAnimate}
          onClickedCancelCell={onClickedCancelCell}
          isWithinSubCategory={isWithinSubCategory}
        />
      </div>

      <div className="w-full md:w-6/12 md:mx-auto">
        {cellIndexContent.questions &&
          cellIndexContent.questions.map((question) => {
            return (
              <Question
                question={question}
                onQuestionAnswered={onQuestionAnswered}
                selection={selection}
                mainOptionSlug={cellIndexContent.mainOptionSlug}
              />
            );
          })}
      </div>
    </Fragment>
  );
};
export default BubblesGrid;
